import type { CompetitorFilters, MyBrandFilters } from "../types/dashboard.types";

// Canonicalizes a filter set into a stable string. Sorts object keys AND scalar
// arrays so chip reorder / key order never reads as a change — this mirrors the
// server's buildFiltersHash, so the dirty check and the request cache key agree.
function canonicalize(value: unknown): unknown {
  if (Array.isArray(value)) {
    return [...value]
      .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)))
      .map(canonicalize);
  }
  if (value !== null && typeof value === "object") {
    const obj = value as Record<string, unknown>;
    return Object.keys(obj)
      .sort()
      .reduce<Record<string, unknown>>((acc, k) => {
        acc[k] = canonicalize(obj[k]);
        return acc;
      }, {});
  }
  return value;
}

export function filtersKey(filters: CompetitorFilters | MyBrandFilters): string {
  return JSON.stringify(canonicalize(filters));
}
